export default __webpack_public_path__ + "static/media/maintenance.a83263b1.svg";